import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyB9cqRVK0Au_qobr0GELorP8idDhi0IR9c",
  authDomain: "disney-clon-42440.firebaseapp.com",
  projectId: "disney-clon-42440",
  storageBucket: "disney-clon-42440.appspot.com",
  messagingSenderId: "331691281310",
  appId: "1:331691281310:web:32beeffb921df504f4648f",
  measurementId: "G-PJ1ZLKST95"
};

firebase.initializeApp(firebaseConfig)

export default firebase;